<footer id="footer"
        class="bg-color-light-extra py-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <p class="mb-16">
                    <a class="navbar-brand"
                       href="./index.html">
                        <img src="./assets/logo-octoplus-color.svg"
                             i18n-alt alt="Logo octoplus">
                    </a>
                </p>
                <p class="text-md-medium color-muted mb-16" i18n>
                    Our mission is to assist companies, from mid-sized to multinational, in enhancing their performance
                    by advancing team maturity in factual cost management and carbon footprint monitoring.
                </p>
                <a routerLink="/contact-us" (click)="scrollToTop()"
                   class="btn btn-primary btn-arrow-left mb-16" i18n>Contact us
                </a>
            </div>
            <div class="offset-lg-1 col-lg-8">
                <div class="row">
                    <div class="col-lg-3">
                        <h4 class="title-footer" i18n>Solutions</h4>
                        <ul class="link-footer">
                            <li>
                                <a routerLink="/cost-viewer" (click)="scrollToTop()" i18n>Cost Viewer</a>
                            </li>
                            <li>
                                <a routerLink="/dashboard-serie" (click)="scrollToTop()" i18n>Dashboard Serie</a>
                            </li>
                            <li>
                                <a routerLink="/dashboard-program" (click)="scrollToTop()" i18n>Dashboard Program</a>
                            </li>
                            <li>
                                <a routerLink="/ebom-manager" (click)="scrollToTop()" i18n>Ebom Manager</a>
                            </li>
                            <li>
                                <a routerLink="/octoplus-impulse" (click)="scrollToTop()" i18n>Octoplus Impulse</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3">
                        <h4 class="title-footer" i18n>Resources</h4>
                        <ul class="link-footer">
                            <li>
                                <a routerLink="/training" (click)="scrollToTop()" i18n>Training</a>
                            </li>
                            <li>
                                <a routerLink="/about-us" (click)="scrollToTop()" i18n>About us</a>
                            </li>
                            <li>
                                <a routerLink="/contact-us" (click)="scrollToTop()" i18n>Contact us</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-6">
                        <h4 class="title-footer" i18n>Get in touch with us</h4>
                        <p i18n>143, avenue de Kéradennec <br>
                            29000 Quimper, France</p>
                        <p>contact&#x40;octoplus-consulting.com</p>
                        <p>+33 (0)7 786 687 11</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container">
        <div class="d-flex justify-content-between">
            <ul class="d-flex gap-24">
                <li>
                    <a href="/privacy-policy" i18n>
                        Privacy policy
                    </a>
                </li>
                <li>
                    <a href="/legal-information" i18n>
                        Legal information
                    </a>
                </li>
                <li>
                    <a href="/terms" i18n>
                        Terms of services
                    </a>
                </li>
            </ul>
            <div>
                <p i18n>© 2026 Octoplus Consulting. All rights reserved.</p>
            </div>
        </div>
    </div>
</footer>
<div id="scrollToTop" class="cursor-pointer"></div>
